import { SocieteEspaceSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteEspaceModel: SelectorModel = {
  name: 'societeEspaces',
  getSelector: SocieteEspaceSelectors.selectAllSocieteEspacesDictionary,
  isReady: SocieteEspaceSelectors.selectIsReadySocieteEspace
};
